// @ts-ignore
import defaultValue from 'lodash.defaultto';
import { Response } from './Response';

export class CustomerIdAndOrderIdIntegrityResponse extends Response {
  get isCustomerIdValid(): boolean {
    return this.trueIfNotDefined(this.data.customerNumberValid);
  }

  get isOrderIdValid(): boolean {
    return this.trueIfNotDefined(this.data.orderNumberValid);
  }

  get customerIdAndOrderIdMatch(): boolean {
    return this.trueIfNotDefined(this.data.customerNumberAndOrderNumberMatch);
  }

  private trueIfNotDefined(value: Nullable<boolean>) {
    return defaultValue(value, true);
  }
}
